import { render, staticRenderFns } from "./ModalValidasiP3b.vue?vue&type=template&id=1e2e19f2&"
import script from "./ModalValidasiP3b.vue?vue&type=script&lang=js&"
export * from "./ModalValidasiP3b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports